const SharedConstants = require('relevant-shared/misc/sharedConstants');

window.relevantDigital.export({ SharedConstants });

module.exports = SharedConstants;
